import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import MockDataInitializer from './components/MockDataInitializer';

// Pages
import HomePage from './pages/HomePage';
import CartPage from './pages/CartPage';
import CheckoutPage from './pages/CheckoutPage';
import ProductDetailsPage from './pages/ProductDetailsPage';
import OrdersPage from './pages/OrdersPage';
import OrderDetailPage from './pages/OrderDetailPage';
import OrderConfirmationPage from './pages/OrderConfirmationPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import WishlistPage from './pages/WishlistPage';
import NotificationsPage from './pages/NotificationsPage';
import TrackOrderPage from './pages/TrackOrderPage';
import AccountLayout from './pages/account/AccountLayout';
import AccountPage from './pages/account/AccountPage';
import AccountAddressesPage from './pages/account/AccountAddressesPage';
import AccountPaymentMethodsPage from './pages/account/AccountPaymentMethodsPage';
import AccountNotificationsPage from './pages/account/AccountNotificationsPage';
import SupportLayout from './pages/support/SupportLayout';
import SupportPage from './pages/support/SupportPage';
import SupportChatPage from './pages/support/SupportChatPage';
import NewTicketPage from './pages/support/NewTicketPage';
import NotFoundPage from './pages/NotFoundPage';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <MockDataInitializer>
        <BrowserRouter>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<HomePage />} />
            <Route path="/cart" element={<CartPage />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/products/:slug" element={<ProductDetailsPage />} />
            <Route path="/orders" element={<OrdersPage />} />
            <Route path="/orders/:orderId" element={<OrderDetailPage />} />
            <Route path="/order-confirmation" element={<OrderConfirmationPage />} />
            <Route path="/wishlist" element={<WishlistPage />} />
            <Route path="/notifications" element={<NotificationsPage />} />
            <Route path="/track-order" element={<TrackOrderPage />} />

            {/* Auth Routes */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />

            {/* Account Routes (Nested) */}
            <Route path="/account" element={<AccountLayout />}>
              <Route index element={<AccountPage />} />
              <Route path="addresses" element={<AccountAddressesPage />} />
              <Route path="payment-methods" element={<AccountPaymentMethodsPage />} />
              <Route path="notifications" element={<AccountNotificationsPage />} />
            </Route>

            {/* Support Routes (Nested) */}
            <Route path="/support" element={<SupportLayout />}>
              <Route index element={<SupportPage />} />
              <Route path="chat" element={<SupportChatPage />} />
              <Route path="tickets/new" element={<NewTicketPage />} />
            </Route>

            {/* 404 */}
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </BrowserRouter>
      </MockDataInitializer>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}

export default App;
